import { ticketsConstants } from '../constants/tickets';

const initialState = {
  additions: [],
  tickets: [],
  ticket: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ticketsConstants.SET_TICKETS_SUCCESS:
      return {
        ...state,
        tickets: [...action.tickets],
        total: action.total,
      };

    case ticketsConstants.SET_TICKET_SUCCESS:
      return {
        ...state,
        ticket: action.ticket,
        additions: [...action.additions],
      };
    case ticketsConstants.MARK_TICKET_AS_READ: {
      return {
        ...state,
        tickets: state.tickets.map((ticket) =>
          ticket.id === action.ticketId ? { ...ticket, isRead: true } : ticket,
        ),
      };
    }
    default:
      return state;
  }
};
